import { Navigate, useParams } from 'react-router-dom'

/** Old collaboration, campaign and offer links land on the deal screen */
const DealRedirect = () => {
  const { id } = useParams<{ id: string }>()
  return <Navigate to={id ? `/deals/${id}` : '/deals'} replace />
}

export default DealRedirect
